import { render, staticRenderFns } from "./addto.vue?vue&type=template&id=20764b31"
import script from "./addto.vue?vue&type=script&lang=js"
export * from "./addto.vue?vue&type=script&lang=js"
import style0 from "./addto.vue?vue&type=style&index=0&id=20764b31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports